import router, { TRouteConfig } from '@/core/utils/router'
import { getALivableRedirectPatch } from '@/router/helpers'
import { getToken } from '@/utils/auth' // get token from cookie
import store from '@/store'
import { useDriverGradesStore } from '@/modules/driverGrades/stores/DriverGrades.store'
import { useFeatureFlagsStore } from '../stores/FeatureFlags.store'

const whiteList = ['/login', '/auth-redirect'] // без редиректа

router.beforeEach(async (to, _from, next) => {
  const hasToken = getToken()

  if (to.path.includes('/public')) {
    return next()
  }

  if (!hasToken) {
    if (whiteList.includes(to.path)) {
      return next()
    } else {
      return next('/login')
    }
  }
  // debugger
  if (!store.getters['userStore/getIsUserSet']()) {
    await store.dispatch('userStore/fetchUser')
  }

  if (Object.keys((store?.state as any)?.globalSettings.settingsData)?.length === 0) {
    await store.dispatch('globalSettings/fetchAllSettings')
  }

  if (useFeatureFlagsStore().can('driverGrades')) {
    const driverGradesStore = useDriverGradesStore()
    if (driverGradesStore.grades.length === 0) {
      await driverGradesStore.fetchGrades()
    }
  }

  if (['/login', '/registration'].includes(to.path)) {
    return next({ name: getALivableRedirectPatch() || 'accounting' })
  }
  const StoreAvailableAliases = store.getters['userStore/getUserRolesAccessCategories']()

  const routes = router.options.routes as TRouteConfig[]
  const allowedRouteNames: string[] = []

  if (!StoreAvailableAliases) return next()

  routes.forEach((route, index) => {
    const children = route.children ?? []

    // Проверяем, есть ли у роутыча дети
    if (children.length === 0) {
      if (StoreAvailableAliases.includes(route.name)) {
        route.meta!.visible = true
        allowedRouteNames.push(route.name)
      } else {
        route.meta!.visible = false
      }
      return
    }

    // Если все таки дети есть, то фильтруем доступы
    const allowedChildRoutes = children.reduce<string[]>((acc, child) => {
      if (StoreAvailableAliases.includes(child.name)) {
        acc.push(child.name)
        allowedRouteNames.push(child.name)
      }
      return acc
    }, [])

    if (allowedChildRoutes.length > 0) {
      route.meta!.allowedRouts = allowedChildRoutes
      route.meta!.visible = true
    } else {
      route.meta!.visible = false
    }
  })

  // Смотрим, куда пытаемся перейти и проверяем - есть ли доступ
  // В случае, если доступа нет - выкидывает на дешбоард и высылает сообщение
  // if (to.name && !allowedRouteNames.includes(to.name.toString())) {
  //   Message({
  //     message: 'У вас нет доступа к этому разделу',
  //     type: 'error',
  //     duration: 3000
  //   })
  //
  //   return next({ name: getALivableRedirectPatch() || 'accounting' })
  // }

  return next()
})
